export default [{
  path: '/AboutCifiContact',//联络方法
  name: 'contactAPage',
  component: () => import('@/view/AboutCifiSpa/contact.vue')
},]




// WEBPACK FOOTER //
// ./src/router/AboutCifiSpa.js